import React, { useCallback, useEffect, useRef, useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";
import $ from "jquery";
import Button from "@mui/material/Button";
import "./Message.scss";
import "./Home.scss";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import axios from "axios";
import DefaultLayout from "../../components/layout/DefaultLayout";
import MessageScreen from "../../components/layout/MessageScreen";
import HistoryLoadingPage from "../../components/layout/HistoryLoadingPage";
import { useHistory, useLocation } from "react-router-dom";
import ChatDisplay from "../../components/response/ChatDisplay";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import Login from "../../app/auth/Login";
import { useSocket } from "../../hooks/useSocket";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const Home = () => {
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingHistory, setLoadingHistory] = useState(false);
  const [AskQuestion, setAskQuestion] = useState("");
  const [errorData, setErrorData] = useState(false);
  const [isHistory, setisHistory] = useState(false);
  const [SessionStart, setSessionStart] = useState(true);
  const [isDefaultPage, setisDefaultPage] = useState(true);
  const [responceData, setResponceData] = useState([]);
  const [GeneratingResponce, setGeneratingResponce] = useState(false);
  const [saveHistory, setSaveHistory] = useState(false);
  const chatWindowRef = useRef(null);
  const [Historyloading, setHistoryloading] = useState(false);
  const [SuccessHistoryloading, setSuccessHistoryloading] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const componentRef = useRef(null);
  const componentRef1 = useRef([]);
  const [viewMore, setViewMore] = useState(false);
  const [responseNum, setResponseNum] = useState(null);
  const [HistoySections, setHistoySections] = useState(true);
  const [historyFlag, setHistoryFlag] = useState(1);
  const [messageId, setMessageId] = useState(0);
  const [faqScreen, setFaqScreen] = useState(true);
  const [query, setQuery] = useState("");
  const [loadingIndex, setLoadingIndex] = useState(0);
  const [GenerateResponceID, setGenerateResponceID] = useState("");
  const inputRef = useRef(null);
  const messageListRef = useRef(null);
  const [divNumber, setDivNumber] = useState(0);
  const history = useHistory();
  const location = useLocation();
  const [historyResponse, setHistoryResponse] = useState([]);
  const [historyDataFlag, setHistoryDataFlag] = useState(false);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const [isRecordingAudio, setIsRecordingAudio] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const [audioBlob, setAudioBlob] = useState(null); // Store recorded audio

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();
  // const { emit, on, off, once, connected, logs, sendQuery,displayedLogs } = useSocket();

  const { displayedLogs, on, off, emit } = useSocket((message) => {
    let cleanMessage = message;
    try {
      const parsed = JSON.parse(message);
      cleanMessage =
        typeof parsed === "string" ? parsed : parsed.message || message;
    } catch {
      cleanMessage = message;
    }
    // console.log("📨 Log message:", cleanMessage);
  });

  // console.log("displayedLogs displayedLogs:", displayedLogs);

  const baseurl = `${process.env.REACT_APP_PYTHON_BACKEND_URL}/ask`;
  const baseurlask_llmeval = `${process.env.REACT_APP_PYTHON_BACKEND_URL}/ask_llmeval`;



  const isTab = useMediaQuery({ query: "(max-width: 768px)" });



  const handleSendClick = async () => {
    if (!userInput.trim()) return;

    // 🧹 Clear previous logs for a fresh start
    setResponceData((prev) => prev.filter((item) => !item.log));

    setErrorData(false);
    setMessageId((id) => id + 1);
    setViewMore(true);
    setIsLoading(true);
    setFaqScreen(false);
    setQuery(userInput);
    setDivNumber((n) => n + 2);

    setResponceData((prev) => [
      ...prev,
      { query: userInput, user: true, loading: true },
    ]);

    if (responceData.length > 2) {
      setLoadingIndex((i) => i + 2);
    }

    const source = axios.CancelToken.source();
    setCancelTokenSource(source);

    // 2️⃣ Tell backend to start streaming logs for this request
    emit("start-logs", { query: userInput });

    try {
      // 3️⃣ Start API request in parallel
      const response = await axios.post(
        baseurl,
        { query: userInput },
        {
          cancelToken: source.token,
        }
      );

      if (response.status === 200) {
        setResponceData((prev) => [
          ...prev,
          { ...response.data.response, user: false },
        ]);
        // Emit askResponse event to notify SocketResponse component
        emit("askResponse", { response: response.data.response });

        setHistoryResponse((prevState) => [
          ...prevState,
          { response: response.data.response },
        ]);

        setSaveHistory(true);
      } else {
        throw new Error("Bad response");
      }
    } catch (err) {
      if (!axios.isCancel(err)) {
        setErrorData(true);
        setResponceData((prev) => [...prev, { error: true, user: false }]);
        // Emit askError event to notify SocketResponse component
        emit("askError", { error: err.message });
      }
    } finally {
      // 4️⃣ Cleanup when done
      setIsLoading(false);
      setCancelTokenSource(null);
      setUserInput("");
      setViewMore(false);
    }
  };


  // const handleSendClickNew = async (userInput,message_id) => {
  //   if (!userInput.trim()) return;
  //   console.log("User Input in handleSendClickNew: ", message_id);

  //   // 🧹 Clear previous logs for a fresh start
  //   setResponceData((prev) => prev.filter((item) => !item.log));

  //   setErrorData(false);
  //   setMessageId((id) => id + 1);
  //   setViewMore(true);
  //   setIsLoading(true);
  //   setFaqScreen(false);
  //   setQuery(userInput);
  //   setDivNumber((n) => n + 2);

  //   setResponceData((prev) => [
  //     ...prev,
  //     { query: userInput, user: true, loading: true },
  //   ]);

  //   if (responceData.length > 2) {
  //     setLoadingIndex((i) => i + 2);
  //   }

  //   const source = axios.CancelToken.source();
  //   setCancelTokenSource(source);

  //   // 2️⃣ Tell backend to start streaming logs for this request
  //   emit("start-logs", { query: userInput });

  //   try {
  //     // 3️⃣ Start API request in parallel
  //     const response = await axios.post(
  //       baseurl,
  //       { query: userInput },
  //       {
  //         cancelToken: source.token,
  //       }
  //     );

  //     if (response.status === 200) {
  //       setResponceData((prev) => [
  //         ...prev,
  //         { ...response.data.response, user: false },
  //       ]);
  //       // Emit askResponse event to notify SocketResponse component
  //       emit("askResponse", { response: response.data.response });

  //       setHistoryResponse((prevState) => [
  //         ...prevState,
  //         { response: response.data.response },
  //       ]);

  //       setSaveHistory(true);
  //     } else {
  //       throw new Error("Bad response");
  //     }
  //   } catch (err) {
  //     if (!axios.isCancel(err)) {
  //       setErrorData(true);
  //       setResponceData((prev) => [...prev, { error: true, user: false }]);
  //       // Emit askError event to notify SocketResponse component
  //       emit("askError", { error: err.message });
  //     }
  //   } finally {
  //     // 4️⃣ Cleanup when done
  //     setIsLoading(false);
  //     setCancelTokenSource(null);
  //     setUserInput("");
  //     setViewMore(false);
  //   }
  // };


  const handleSendClickNew = async (userInput, message_id) => {
    if (!userInput.trim()) return;

    setResponceData((prev) => prev.filter((item) => !item.log));
    setErrorData(false);
    setViewMore(true);
    setIsLoading(true);
    setFaqScreen(false);
    setQuery(userInput);
    setDivNumber((n) => n + 2);

    // setResponceData((prev) => [
    //   ...prev,
    //   { query: userInput, user: true, loading: true },
    // ]);

    // ✅ Add or Update user input item
    setResponceData((prev) => {
      const index = prev.findIndex((item) => item.message_id === message_id);

      if (index !== -1) {
        // If found, update existing entry
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          user: true,
          loading: true,
        };
        return updated;
      }

      // Otherwise, append a new entry
      return [
        ...prev,
        { query: userInput, user: true, loading: true, message_id },
      ];
    });


    if (responceData.length > 2) {
      setLoadingIndex((i) => i + 2);
    }

    const source = axios.CancelToken.source();
    setCancelTokenSource(source);

    emit("start-logs", { query: userInput });

    try {
      const response = await axios.post(
        baseurlask_llmeval,
        { query: userInput, Response_ID: message_id },
        { cancelToken: source.token }
      );

      if (response.status === 200) {
        const newResponse = { ...response.data.response, user: false };

        // ✅ Replace existing object where message_id matches
        setResponceData((prev) =>
          prev.map((item) =>
            item.message_id === message_id ? newResponse : item
          )
        );

        // Emit to socket listeners
        emit("askResponse", { response: response.data.response });

        setHistoryResponse((prevState) => [
          ...prevState,
          { response: response.data.response },
        ]);

        setSaveHistory(true);
      } else {
        throw new Error("Bad response");
      }
    } catch (err) {
      if (!axios.isCancel(err)) {
        setErrorData(true);
        setResponceData((prev) => [...prev, { error: true, user: false }]);
        emit("askError", { error: err.message });
      }
    } finally {
      setIsLoading(false);
      setCancelTokenSource(null);
      setUserInput("");
      setViewMore(false);
    }
  };

  const handleCancelClick = () => {
    // if (cancelTokenSource !== null) {
    // }
    cancelTokenSource?.cancel("Request canceled by the user");
    setCancelTokenSource(null);
    console.log("Cancel token set to null");
  };

  useEffect(() => {
    return () => {
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Component unmounted");
      }
    };
  }, [cancelTokenSource]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!isLoading) {
      handleSendClick();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !isLoading) {
      handleFormSubmit(e);
    }
  };

  const handleExternalTextClick = (text) => {
    setUserInput(text);
    inputRef.current.focus();
  };

  const newChatStart = useCallback(() => {
    handleCancelClick();
    setisDefaultPage(false);
    setResponceData([]);
    setAskQuestion("");
    setisHistory(false);
    setHistoryloading(false);
    setSessionStart(true);
    setDivNumber(0);
    setResponseNum(0);
    setFaqScreen(true);
    setHistoryResponse([]);
    setUserInput("");
    setIsLoading(false);
    $(".bg-dark-card").removeClass("faqActive");
  }, []);

  useEffect(() => {
    if (divNumber > 2) {
      setTimeout(scrollToBottom, 200);
    }
  }, [divNumber]);

  useEffect(() => {
    if (isDefaultPage) {
      handleCancelClick();
    }
  }, [isDefaultPage]);


  const scrollToBottom = () => {
    let divId = "message-" + (divNumber - 2);
    let targetDiv = document.getElementById(divId);
    // console.log("Div Number: ", divId, targetDiv);

    if (targetDiv === null) {
      targetDiv = document.getElementById(divId);

      if (targetDiv) {
        targetDiv.scrollIntoView({
          behavior: "smooth", // Smooth scroll
          block: "start", // Center the div vertically in the viewport
        });
      }
    } else {
      if (targetDiv) {
        targetDiv.scrollIntoView({
          behavior: "smooth", // Smooth scroll
          block: "start", // Center the div vertically in the viewport
        });
      }
    }
  };


  const fetchHistoryDataItem = useCallback(async (responseID, summary, Id) => {
    
    history.push(`/history?id=${responseID}`);
  }, []);

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);

    let paramsObject = {};
    if (Array.from(searchParams).length > 0) {
      for (let [key, value] of searchParams.entries()) {
        paramsObject[key] = value;
      }
      if (paramsObject.historyQuery) {
        // Set user input and isDefaultPage before replacing history
        setisDefaultPage(false);
        setUserInput(paramsObject.historyQuery);
        localStorage.setItem("activeItem", null);

        // Use setTimeout to ensure state updates before history.replace
        setTimeout(() => {
          history.replace({
            pathname: location.pathname,
            search: "",
          });
        }, 0);
      } else {
        localStorage.setItem("activeItem", paramsObject?.responseId);

        // Do not clear userInput if not needed
        setTimeout(() => {
          history.replace({
            pathname: location.pathname,
            search: "",
          });
        }, 0);
        fetchHistoryDataItem(
          paramsObject.responseId,
          paramsObject.summary,
          paramsObject.chatId
        );
      }
    } else {
      localStorage.setItem("activeItem", null);
    }
  }, []);

  const HistorySave = async () => {
    const baseUrl = `${process.env.REACT_APP_BASE_URL}/aadi/history2.0/data2.0`;
    // const baseUrl = ` http://127.0.0.1:5000/aadi/history2.0/data2.0`;

    const HistoryDataSave = [
      {
        responseID: GenerateResponceID || "",
        session: SessionStart,
        email: localStorage.getItem("userinfo"),
        data: historyResponse,
        responselogs: displayedLogs,
      },
    ];

    try {
      const response = await axios.post(baseUrl, HistoryDataSave);
      const data = response.data;
      setGenerateResponceID(data.response_id);
      if (response.status === 200) {
        setTimeout(() => {
          setSuccessHistoryloading(false);
        }, 2000);

        setHistoryDataFlag(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (saveHistory === true) {
      HistorySave();
      setTimeout(() => {
        setSaveHistory(false);
      }, 1000);
    }
  }, [saveHistory]);

  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };
  window.addEventListener("resize", appHeight);
  useEffect(() => {
    appHeight();
  }, []);

  useEffect(() => {
    // Only update userInput if transcript has content and is different from current value
    if (transcript && transcript.trim() !== "" && transcript !== userInput) {
      setUserInput(transcript);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);

  useEffect(() => {
    if (userInput === "") {
      resetTranscript();
    }
  }, [userInput]);

  // Toggle Speech Recognition
  const toggleListening = () => {
    if (listening) {
      SpeechRecognition.stopListening(); // Stop listening when clicked again
    } else {
      resetTranscript(); // Optional: clear previous transcript
      SpeechRecognition.startListening({ continuous: true }); // Start listening
    }

    // Start recording automatically once listening begins
    toggleAudioRecording();
  };
  const audioUrlRef = useRef(""); // Ref to store the latest audioUrl

  // Start/Stop Audio Recording
  // Start/Stop Audio Recording
  const toggleAudioRecording = () => {
    if (isRecordingAudio) {
      setIsRecordingAudio(false);

      // Stop the MediaRecorder and the stream
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream
        .getTracks()
        .forEach((track) => track.stop()); // Stop the stream

      // Create the Blob and URL for the recorded audio
      const audioBlob = new Blob(chunksRef.current, { type: "audio/wav" });
      const audioUrl = URL.createObjectURL(audioBlob);
      audioUrlRef.current = audioUrl; // Update the ref with the new audio URL
      setAudioUrl(audioUrl); // Update the state for re-render

      chunksRef.current = []; // Clear the chunks after stopping
    } else {
      setIsRecordingAudio(true);

      // Start the MediaRecorder
      navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
        mediaRecorderRef.current = new MediaRecorder(stream);
        mediaRecorderRef.current.ondataavailable = (e) => {
          if (e.data.size > 0) {
            chunksRef.current.push(e.data); // Collect audio chunks as they are recorded
          }
        };
        mediaRecorderRef.current.onstop = () => {
          // This event is triggered when recording stops
          const audioBlob = new Blob(chunksRef.current, { type: "audio/wav" });
          const audioUrl = URL.createObjectURL(audioBlob);
          audioUrlRef.current = audioUrl;
          setAudioUrl(audioUrl);
        };
        mediaRecorderRef.current.start();
      });
    }
  };

  // Play the recorded audio (ensure to use the latest audio URL)
  const playAudio = () => {
    const latestAudioUrl = audioUrlRef.current;
    if (latestAudioUrl) {
      const audio = new Audio(latestAudioUrl);
      audio.play();
    }
  };

  // Check if the browser supports speech recognition
  if (!browserSupportsSpeechRecognition) {
    return <span>Your browser does not support speech recognition.</span>;
  }

  return (
    <>
      <AuthenticatedTemplate>
        <div
          id="homePage"
          style={{ overflow: "hidden", height: "var(--app-height)" }}
          className={`${isDefaultPage ? "default-home-page" : ""}`}
        >
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout
              setisDefaultPage={setisDefaultPage}
              fetchHistoryDataItem={fetchHistoryDataItem}
              setSuccessHistoryloading={setSuccessHistoryloading}
              newChatStart={newChatStart}
              historyFlag={historyFlag}
              setHistoryFlag={setHistoryFlag}
              isDefaultPage={isDefaultPage}
              page="Home"
              historyDataFlag={historyDataFlag}
              setHistoryDataFlag={setHistoryDataFlag}
            />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />

              <div
                id="mainHome"
                className={`${isDefaultPage ? "default-setting" : ""}`}
              >
                <div
                  id={
                    HistoySections
                      ? "mainChatContent_new"
                      : "mainChatContent_new"
                  }
                  style={{ width: "100%" }}
                  className={`${isDefaultPage ? "default-page" : ""}`}
                >
                  {isDefaultPage ? (
                    <>
                      <DefaultLayout newChatStart={newChatStart} />
                    </>
                  ) : (
                    <>
                      {Historyloading ? (
                        <>
                          <HistoryLoadingPage />
                        </>
                      ) : (
                        <div ref={chatWindowRef} id="statistic1">
                          <div
                            className={isHistory ? "fullHeight" : ""}
                            id="statistic"
                            ref={messageListRef}
                          >
                            {!faqScreen && (
                              <ChatDisplay
                                responceData={responceData}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                query={query}
                                errorData={errorData}
                                loadingIndex={loadingIndex}
                                setResponceData={setResponceData}
                                isHistory={isHistory}
                                page="Home"
                                handleSendClickNew={handleSendClickNew}
                                displayedLogs={displayedLogs}
                              />
                            )}
                            {faqScreen &&
                              responceData &&
                              responceData.length === 0 && (
                                <>
                                  <MessageScreen
                                    handleExternalTextClick={
                                      handleExternalTextClick
                                    }
                                    setUserInput={setUserInput}
                                  />
                                </>
                              )}
                          </div>
                          <div className="col-12 inputTextboxHome">
                            <div
                              style={{
                                justifyContent: "flex-start",
                                justifyItems: "flex-start",
                                width: "180px",
                              }}
                            >
                              {isTab ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  // style={{
                                  //   background: "#bb1ccc",
                                  //   color: "#ffffff",
                                  //   border: "none",
                                  //   boxShadow: "none",
                                  //   height: "37px",
                                  // }}
                                  className="submit_btn"
                                  onClick={newChatStart}
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <AddIcon
                                    style={{ height: "120%", width: "100%" }}
                                  />
                                </Button>
                              ) : (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  startIcon={<AddIcon />}
                                  // style={{
                                  //   background: "#bb1ccc",
                                  //   color: "#ffffff",
                                  //   border: "none",
                                  //   boxShadow: "none",
                                  //   height: "37px",
                                  // }}
                                  className="submit_btn"
                                  onClick={newChatStart}
                                >
                                  New Chat
                                </Button>
                              )}
                            </div>
                            <form
                              onSubmit={handleFormSubmit}
                              className="chat-form"
                            >
                              <div className="input-group mt-0 mb-0">
                                <input
                                  ref={inputRef}
                                  id="chat_pdf_input"
                                  placeholder="Ask a question ..."
                                  className="message-type-box form-control border-0"
                                  type="text"
                                  autoComplete="off"
                                  value={userInput}
                                  onChange={(e) => setUserInput(e.target.value)}
                                  onKeyDown={handleKeyPress}
                                  style={{ paddingRight: "40px" }} // space for the icon inside input
                                />
                                <IconButton
                                  onClick={toggleListening}
                                  style={{
                                    position: "absolute",
                                    right: audioUrl ? "125px" : "75px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    zIndex: 99999,
                                  }}
                                >
                                  {listening ? (
                                    <MicIcon color="primary" />
                                  ) : (
                                    <MicOffIcon color="error" />
                                  )}
                                </IconButton>
                                {audioUrl && (
                                  <IconButton
                                    onClick={playAudio}
                                    style={{
                                      position: "absolute",
                                      right: "70px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      zIndex: 99999,
                                    }}
                                  >
                                    {/* {listening ? ( */}
                                    <GraphicEqIcon color="primary" />
                                    {/* ) : ( */}
                                    {/* <MicOffIcon color="error" /> */}

                                    {/* )} */}
                                  </IconButton>
                                )}

                                <Button
                                  id="send_pdf_chat"
                                  className="btn btn-light-success text-success sendbtn borderColorNew"
                                  onClick={handleSendClick}
                                  disabled={isLoading}
                                  type="submit"
                                >
                                  {isLoading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    </>
                                  ) : (
                                    <SendIcon
                                      style={{ color: "#bb1ccc" }}
                                      className="colorCss"
                                    />
                                  )}
                                </Button>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default Home;
